import { useQuery } from '@tanstack/react-query';
import { createContext, PropsWithChildren, useContext } from 'react';
import Api from '../components/api/api';
import { useAuthContext } from './authContext';

interface Profile {
  auth_provider: string;
  available_balance: number;
  create_at: string;
  email: string;
  full_name: string;
  id: string;
  status: string;
  total_balance: number;
  updated_at: string;
}

interface ProfileContextType {
  profile: Profile;
}

const defaultProfile = {
  auth_provider: '',
  available_balance: 0,
  create_at: '',
  email: '',
  full_name: '',
  id: '',
  status: '',
  total_balance: 0,
  updated_at: '',
};

const ProfileContext = createContext<ProfileContextType>({
  profile: defaultProfile,
});

const api = Api();

export function ProfileContextProvider({ children }: PropsWithChildren) {
  const { accessToken } = useAuthContext();
  const { data: profile } = useQuery({
    initialData: defaultProfile,
    queryKey: ['getProfile'],
    queryFn: async () => {
      const { data } = await api.getProfile();

      return data;
    },
    enabled: !!accessToken,
  });

  return <ProfileContext.Provider value={{ profile }}>{children}</ProfileContext.Provider>;
}

export const useProfileContext = () => {
  const context = useContext(ProfileContext);
  return context;
};
